import { Injectable } from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ErrorTexts} from 'src/app/models/error-texts.enum';

@Injectable()
export class ValidationService {
  private requireCounter = 0;

  constructor(
      private toastrService: ToastrService,
  ) { }

  public validateForm(form: UntypedFormGroup): void {
      for (const control in form.controls) {
          if (control) {
              form.get(control).markAsDirty();
              this.handleError(form.get(control).errors);
          }
      }
      this.requireCounter = 0;
  }

  private handleError(errors): void {
    for (const error in errors) {
      if (error) {
          switch (error) {
              case 'required': {
                  if (!this.requireCounter) {
                      this.toastrService.error(ErrorTexts.required);
                      this.requireCounter++;
                  }
                  break;
              }
              case 'minlength': {
                  this.toastrService.error(ErrorTexts.minLength);
                  break;
              }
              case 'pattern': {
                  this.toastrService.error(ErrorTexts.regExp);
                  break;
              }
              case 'mismatch': {
                  this.toastrService.error(ErrorTexts.confirmationError);
                  break;
              }
              default: {
                  this.toastrService.error('Incorrect form data');
                  break;
              }
          }
      }
    }
  }
}
